var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"mapRef",staticClass:"single_ride_map_design",attrs:{"center":_vm.rideCenter,"zoom":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }